import {
  Text,
  Box,
  Stack,
  IconTick,
  Columns,
  Column,
} from 'braid-design-system';
import React from 'react';

const ClassicBullets = () => (
  <Box paddingBottom="gutter">
    <Stack space="large" align="left">
      <Columns space="small">
        <Column width="content">
          <IconTick tone="formAccent" />
        </Column>
        <Column>
          <Box style={{ marginTop: '4px' }}>
            <Text size="large">30 day listing</Text>
          </Box>
        </Column>
      </Columns>
      <Columns space="small">
        <Column width="content">
          <IconTick tone="formAccent" />
        </Column>
        <Column>
          <Box style={{ marginTop: '4px' }}>
            <Text size="large">Your Job Ad emailed to relevant candidates</Text>
          </Box>
        </Column>
      </Columns>
    </Stack>
  </Box>
);

const StandOutBullets = () => (
  <Stack space="large" align="left">
    <Text weight="strong" size="large">
      Everything in Classic, plus...
    </Text>
    <Columns space="small">
      <Column width="content">
        <IconTick tone="formAccent" />
      </Column>
      <Column>
        <Box style={{ marginTop: '4px' }}>
          <Text size="large">Logo and cover image to promote brand</Text>
        </Box>
      </Column>
    </Columns>
    <Columns space="small">
      <Column width="content">
        <IconTick tone="formAccent" />
      </Column>
      <Column>
        <Box style={{ marginTop: '4px' }}>
          <Text size="large">Key selling points to attract candidates</Text>
        </Box>
      </Column>
    </Columns>
  </Stack>
);

const PremiumBullets = () => (
  <Stack space="large" align="left">
    <Text size="large" weight="strong">
      Everything in StandOut, plus...
    </Text>
    <Columns space="small">
      <Column width="content">
        <IconTick tone="formAccent" />
      </Column>
      <Column>
        <Box style={{ marginTop: '4px' }}>
          <Text size="large">Priority listing in search</Text>
        </Box>
      </Column>
    </Columns>
    <Columns space="small">
      <Column width="content">
        <IconTick tone="formAccent" />
      </Column>
      <Column>
        <Box style={{ marginTop: '4px' }}>
          <Text size="large">Priority in candidate recommendations</Text>
        </Box>
      </Column>
    </Columns>
    <Columns space="small">
      <Column width="content">
        <IconTick tone="formAccent" />
      </Column>
      <Column>
        <Box style={{ marginTop: '4px' }}>
          <Text size="large">Get candidates faster</Text>
        </Box>
      </Column>
    </Columns>
  </Stack>
);

const SellingPoints = ({ ad }: { ad: number }) => (
  <Box alignItems="flexStart" textAlign="left">
    {ad === 0 && <ClassicBullets />}
    {ad === 1 && <StandOutBullets />}
    {ad === 2 && <PremiumBullets />}
  </Box>
);

export default SellingPoints;
